export default "__VITE_ASSET__DZEAsauM__"